import { Button, Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

import { TIndirectTaxLineItemTaxLogicRow } from '../types';

const IndirectTaxLineItemTaxLogicCheck = ({
  row,
  isLast,
}: {
  row: TIndirectTaxLineItemTaxLogicRow;
  isLast: boolean;
}) => (
  <div className="flex gap-lg">
    <div className="flex flex-col items-center">
      {row.answer ? (
        <span className="flex size-4 shrink-0 items-center justify-center rounded-full bg-bg-success">
          <Icons.Check className="size-2.5 text-text-success" />
        </span>
      ) : (
        <span className="flex size-4 shrink-0 items-center justify-center rounded-full bg-utility-error-50">
          <Icons.X className="size-2.5 text-text-error" />
        </span>
      )}
      {!isLast && <div className="flex-1 w-px bg-border-secondary mt-xxs" />}
    </div>
    <div
      className={cn('flex flex-col items-start gap-xxs', !isLast && 'pb-2xl')}
    >
      <span className="txt-small-medium text-text-primary">{row.question}</span>
      <span className="txt-small-regular text-text-secondary">
        {row.answer ? 'Yes' : 'No'}
      </span>
      {row.onView && (
        <Button variant="brand-link" size="sm" onClick={row.onView}>
          {row.linkLabel}
        </Button>
      )}
    </div>
  </div>
);

export { IndirectTaxLineItemTaxLogicCheck };
